import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { DASHBOARD } from '../constant/actionTypes';

const apiEndPoint = constants.ADMIN_URL;

const getDashboardData = () => (dispatch) => httpservice()
  .get(`${apiEndPoint}${constants.API.DASHBOARD}`)
  .then((response) => {
    dispatch({
      payload: response.data,
      type: DASHBOARD.USER.SUCCESS,
    });
  })
  .catch((error) => {
    dispatch({
      payload: error,
      type: DASHBOARD.USER.ERROR,
    });
  });

export default getDashboardData;
